import { css } from '@emotion/core';
import colors from '../../../../../styles/colors';

export const mainTable = css`
  &.mainTable {
    width: 100%;
  }

  .styleForNumbers {
    display: flex;
    justify-content: end !important;
  }

  .nameFixedWidth {
    width: 15%;
  }

  .fixBorder {
    border: 3px solid #e1f4fd;
  }

  th {
    padding-right: 0.4rem;
  }

  td {
    padding-left: 1rem;
    padding-right: 0.5rem;
  }

  &.gray-table {
    .tableHeading {
      background: ${colors.gray[50]};
      color: ${colors.gray[800]};

      th:last-child {
        > div {
          justify-content: end;
        }
      }
    }
    tbody tr {
      border-bottom: 1px solid ${colors.neutralGray[50]};
      &:hover,
      &:active,
      &:focus {
        background: ${colors.neutralGray[50]};
      }
    }
  }
  &.simple-bordered-table {
    background: ${colors.white};
    td,
    th {
      border: 1px solid #e5e7eb;
      font-size: 0.875rem;
      line-height: 1.25rem;
      font-weight: 400;
      padding: 1rem 1.5rem;
    }
    th {
      line-height: 1rem;
      font-weight: 700;
      color: ${colors.gray[700]};
    }
    .tableHeading {
      color: ${colors.gray[800]};
      background: none;

      th:last-child {
        > div {
          justify-content: end;
        }
      }
    }
    tbody tr {
      &:hover,
      &:active,
      &:focus {
        background: ${colors.neutralGray[50]};
      }
    }
  }
`;

export const tableHeading = css`
  background: #e1f4fd;
  height: 45px;
  padding-left: 23px;
  padding-right: 23px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: capitalize;
  color: #3a498e;
  position: sticky;
  top: 0;
  z-index: 9;
`;

export const tableHeadingNonSticky = css`
  background: #e1f4fd;
  height: 45px;
  padding-left: 23px;
  padding-right: 23px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  text-transform: capitalize;
  color: #3a498e;
  position: static;
`;

export const recruiterNameCell = css`
  color: #607d8b;
  font-size: 14px;

  &.name {
    margin-right: 20px;
  }

  &.low,
  &.faible {
    color: #b33636;
  }
  &.medium,
  &.oyen {
    color: #938511;
  }

  &.high,
  &.haut {
    color: #5c995e;
  }
`;

export const sortIconWrapper = css`
  display: flex;
  align-items: center;
  margin-left: 5px;
`;
